export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const OPEN_NOTIFICATION = 'OPEN_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';
export const SET_CLASSES = 'SET_CLASSES';


export function setNotification(message) {
  return (dispatch) => {
    dispatch({
      type: SET_NOTIFICATION,
      message
    });
  };
}

export function setClassName(classes) {
  return (dispatch) => {
    dispatch({
      type: SET_CLASSES,
      classes
    });
  };
}

export function openNotification() {
  return (dispatch) => {
    dispatch({
      type: OPEN_NOTIFICATION
    });
  };
}

export function closeNotification() {
  return (dispatch) => {
    dispatch({
      type: CLOSE_NOTIFICATION
    });
  };
}


// WEBPACK FOOTER //
// ./actions/notification.js